{
  "name": "@blazeapps/dsteem",
  "version": "0.12.2",
  "description": "Modernized Steem blockchain RPC client library for Node.js, browsers, and React Native (fork of jnordberg/dsteem).",
  "author": "Johan Nordberg",
  "contributors": [
    {
      "name": "blaze.apps",
      "url": "https://github.com/blazeapps007"
    }
  ],
  "license": "BSD-3-Clause",
  "main": "./dist/index.cjs",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "react-native": "./dist/index.browser.cjs",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "react-native": "./dist/index.browser.mjs",
      "browser": "./dist/index.browser.mjs",
      "import": "./dist/index.mjs",
      "require": "./dist/index.cjs"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist"
  ],
  "engines": {
    "node": ">=22.0.0"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/blazeapps007/dsteem.git"
  },
  "homepage": "https://blazeapps007.github.io/dsteem/",
  "bugs": {
    "url": "https://github.com/blazeapps007/dsteem/issues"
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "build": "tsup",
    "lint": "eslint src test",
    "test": "mocha",
    "test:all": "mocha --extension ts test",
    "coverage": "c8 npm test",
    "test:browser": "npm run build && playwright test",
    "build:docs": "typedoc",
    "prepublishOnly": "npm run lint && npm run build && npm test"
  },
  "keywords": [
    "blockchain",
    "client",
    "rpc",
    "steem",
    "dsteem",
    "blazeapps"
  ],
  "dependencies": {
    "@noble/curves": "^1.9.7",
    "@noble/hashes": "^1.8.0",
    "bs58": "^4.0.1",
    "bytebuffer": "^5.0.1",
    "verror": "^1.10.0"
  },
  "devDependencies": {
    "@eslint/js": "^9.15.0",
    "@playwright/test": "^1.60.0",
    "@types/bs58": "^4.0.4",
    "@types/bytebuffer": "^5.0.33",
    "@types/mocha": "^10.0.10",
    "@types/node": "^22.10.1",
    "@types/verror": "^1.10.3",
    "c8": "^10.1.3",
    "esbuild-plugin-polyfill-node": "^0.3.0",
    "eslint": "^9.15.0",
    "globals": "^15.12.0",
    "lorem-ipsum": "^1.0.6",
    "mocha": "^11.7.6",
    "ts-node": "^10.9.2",
    "tsup": "^8.5.1",
    "typedoc": "^0.28.19",
    "typescript": "^5.6.3",
    "typescript-eslint": "^8.16.0"
  }
}
